import kkLang from "./language/kk.json";
import noLang from "./language/no.json";
import svLang from "./language/sv.json";
import kkRegion from "./region/kk.json";
import noRegion from "./region/no.json";
import svRegion from "./region/sv.json";
import kkTranslations from "./translation/kk.json";
import noTranslations from "./translation/no.json";
import svTranslations from "./translation/sv.json";

const SUPPORTED_LANGUAGES_AND_REGIONS = ["kk", "no", "sv"];

const LANGUAGE_MAP = {
    kk: kkLang,
    no: noLang,
    sv: svLang,
};

const REGION_MAP = {
    kk: kkRegion,
    no: noRegion,
    sv: svRegion,
};

const TRANSLATION_MAP = {
    kk: kkTranslations,
    no: noTranslations,
    sv: svTranslations,
};

const DEFAULT_LANGUAGE = "no";

const TIMEZONE = "timezone";
const PHONE_ISO_CODE = "phone-iso-code";
const HOLIDAY_REGION = "holiday-region";
const ZIP_FORMAT = "zip-format";
const MONEY_FORMAT = "money-format";
const NUMBER_REGION = "number-region";
const DATE_FORMAT = "date-formats";
const BIRTHDATE_FORMAT = "birthdate-format";
const MOMENT = "moment";
const DATEPICKER = "datepicker";
const INTL_ICU = "intl-icu";

const configHandler = {
    debug: false,

    languageKey: DEFAULT_LANGUAGE,
    regionKey: DEFAULT_LANGUAGE,

    language: LANGUAGE_MAP[DEFAULT_LANGUAGE],
    region: REGION_MAP[DEFAULT_LANGUAGE],
    translations: TRANSLATION_MAP[DEFAULT_LANGUAGE],

    supportedLanguagesAndRegions: function () {
        return SUPPORTED_LANGUAGES_AND_REGIONS;
    },
    boot(options) {
        this.setLanguageKey(options.language);
        this.setRegionKey(options.region);
    },

    setRegionKey: function (key) {
        this.regionKey = key !== undefined && this.supportedLanguagesAndRegions().indexOf(key) !== -1 ? key : this.regionKey;
        this.region = REGION_MAP[this.regionKey];
    },

    setLanguageKey: function (key) {
        this.languageKey = key !== undefined && this.supportedLanguagesAndRegions().indexOf(key) !== -1 ? key : this.languageKey;
        this.language = LANGUAGE_MAP[this.languageKey];
        this.translations = TRANSLATION_MAP[this.languageKey];
    },

    setDebug: function (debug) {
        this.debug = Boolean(debug);
    },

    errorMessages: function () {
        return this.translations.errors;
    },

    getTimezone: function () {
        return this.language[TIMEZONE];
    },

    getMomentTimezone: function () {
        return this.language[MOMENT];
    },

    getDatepickerTimezone: function () {
        return this.language[DATEPICKER];
    },

    getIntlICU: function () {
        return this.language[INTL_ICU];
    },

    getHolidayRegion: function () {
        return this.region[HOLIDAY_REGION];
    },

    getPhoneIsoCodeRegion: function () {
        return this.region[PHONE_ISO_CODE];
    },

    getZipFormats: function () {
        return this.region[ZIP_FORMAT];
    },

    getZipFormat: function (key) {
        return this.region[ZIP_FORMAT][key];
    },

    getNumberRegion: function () {
        return this.region[NUMBER_REGION];
    },

    getMoneyFormats: function () {
        return this.region[MONEY_FORMAT];
    },

    getMoneyFormat: function (key) {
        return this.region[MONEY_FORMAT][key];
    },

    getDateFormats: function () {
        return this.language[DATE_FORMAT];
    },

    getDateFormat: function (key) {
        return this.language[DATE_FORMAT][key];
    },

    getBirthdateFormat: function (key) {
        return this.language[BIRTHDATE_FORMAT][key];
    },
};

export default configHandler;
